import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { DOMAIN_SHORT_NAMES, getScoreLevel } from '../../lib/api';

export default function MindWheel({ domainScores, size = 'default' }) {
  if (!domainScores || domainScores.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-muted-foreground">
        No data available
      </div>
    );
  }

  const data = domainScores.map((ds) => {
    const level = getScoreLevel(ds.dysfunction_score);
    return {
      domain: DOMAIN_SHORT_NAMES[ds.domain] || ds.domain,
      dysfunction: ds.dysfunction_score,
      health: 100 - ds.dysfunction_score,
      fill: level.color,
      fullName: ds.domain.replace(/_/g, ' ')
    };
  });

  const height = size === 'large' ? 400 : 300;

  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="75%" data={data}>
          <PolarGrid 
            stroke="hsl(var(--border))"
            strokeDasharray="3 3"
          />
          <PolarAngleAxis 
            dataKey="domain"
            tick={{ fill: 'hsl(var(--foreground))', fontSize: 13, fontWeight: 500 }}
            tickLine={false}
          />
          <PolarRadiusAxis 
            angle={90}
            domain={[0, 100]}
            tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: 11 }}
            tickCount={5}
          />
          <Radar
            name="Health Score"
            dataKey="health"
            stroke="hsl(var(--primary))"
            fill="hsl(var(--primary))"
            fillOpacity={0.2}
            strokeWidth={2}
            dot={{ r: 4, fill: 'hsl(var(--primary))' }}
          />
          <Tooltip 
            content={({ active, payload }) => {
              if (active && payload && payload.length) {
                const item = payload[0].payload;
                const level = getScoreLevel(item.dysfunction);
                return (
                  <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
                    <p className="font-medium text-sm mb-1" style={{ textTransform: 'capitalize' }}>
                      {item.fullName}
                    </p>
                    <div className="space-y-1 text-xs">
                      <div className="flex items-center justify-between gap-4">
                        <span className="text-muted-foreground">Dysfunction:</span>
                        <span className="font-mono font-medium" style={{ color: level.color }}>
                          {item.dysfunction.toFixed(1)}
                        </span>
                      </div>
                      <div className="flex items-center justify-between gap-4">
                        <span className="text-muted-foreground">Health:</span>
                        <span className="font-mono font-medium text-primary">
                          {item.health.toFixed(1)}
                        </span>
                      </div>
                      <div className="pt-1 border-t border-border mt-1">
                        <span 
                          className="px-2 py-0.5 rounded-full text-xs"
                          style={{ backgroundColor: `${level.color}20`, color: level.color }}
                        >
                          {level.label}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              }
              return null;
            }}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
